
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
@Component({ name: 'stepHead' })
export default class indexView extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  title!: string
  @Prop({
    type: Boolean,
    default: 0,
  })
  isShow!: boolean
}
